/* eslint-disable no-param-reassign */
import _, { defaults } from 'underscore';
import { InlineEditableColumnPrompt } from '@bingads-webui-campaign/summary-grid-helper';
import { initializeAdCustomizer, getCharCountExcludingAdCustomizers } from '@bingads-webui-campaign/ad-customizers-next';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { withUiBlock } from '@bingads-webui/uiblocker';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import { getODataErrors } from '@bingads-webui-campaign/api-errors';
import { ResponsiveSearchAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { fetchAd, processAssets } from './ad-helper';
import { instrumentationSchema } from './instrumentation-schema';

export function TextInlineEditRSA({
  item, newPosition, view, i18n, scope, itemToSchemaMap, schemaToItemMap, serverContext, permissions,
}) {
  const newSchema = cloneDeep(ResponsiveSearchAd);
  const fieldName = itemToSchemaMap[item.AssociationType];
  newSchema.properties[fieldName].required = true;
  newSchema.properties[fieldName] = _.omit(newSchema.properties[fieldName], 'maxLength');
  item[fieldName] = item.Asset.Text;
  const { CurrentAccount } = serverContext;
  const { TimeZone } = CurrentAccount;
  instrumentation.addScenario(instrumentationSchema);
  const logScenario = instrumentation.assetGrid.create();
  const activityLogger = logScenario.inlineEditRSAAsset && logScenario.inlineEditRSAAsset.create();

  initializeAdCustomizer({
    deps: {
      i18n,
      permissions,
      instrumentation,
      timeZone: TimeZone,
      showAdCustomizers: true,
      edmCampaign,
      jsDataCampaign: jsdata,
      scope,
    },
    adType: 'ResponsiveSearchAd',
  });

  return InlineEditableColumnPrompt({
    position: newPosition,
    item,
    view,
    i18n,
    fieldName,
    schema: newSchema,
    customValidators: {
      [fieldName]: {
        isValid: (value) => {
          const charCount = getCharCountExcludingAdCustomizers({
            text: value,
            adType: 'ResponsiveSearchAd',
            field: item.AssociationType,
          });
          return charCount <= ResponsiveSearchAd.properties[fieldName].maxLength;
        },
        message: i18n.getString('Validation_String_Max_Length', { maxlength: ResponsiveSearchAd.properties[fieldName].maxLength }),
      },
    },
    saveModel: (updated, editorView) => {
      const {
        campaignId, adGroupId, adType, adId,
      } = scope.values;

      const callScope = {
        entitySet: edmCampaign.currentAccount.Campaigns.$withKey(campaignId).AdGroups.$withKey(adGroupId).Ads,
        cacheResponse: false,
        scenario: 'ads-grid',
      };
      const commonParams = {
        Campaign: { Id: campaignId },
        AdGroup: { Id: adGroupId },
        Type: adType,
        Id: adId,
      };

      fetchAd({
        edm: edmCampaign,
        jsData: jsdata,
        scope: scope.values,
      }).then((ad) => {
        const params = defaults(processAssets(ad[0], updated, fieldName, schemaToItemMap), commonParams);

        jsdata.ResponsiveSearchAd
          .create(params, callScope)
          .then(() => {
            if (permissions && permissions.dynamic.AdStrengthInAssetTopGrid) {
              view.grid.showAdStrength.refreshAdItem();
            }
            activityLogger.trace(`success inline edit for RSA Asset for ad ${ad[0].Id}`);
            editorView.trigger('save');
            view.grid.gridView.refresh(true);
          })
          .catch((response) => {
            activityLogger.trace(`fail inline edit for RSA Asset for ad ${ad[0].Id}: ${JSON.stringify(response)}`);
            if (!response || !response.errors) {
              editorView.setErrors({
                [fieldName]: i18n.getString('GenericErrorMessage_Short'),
              });
            } else {
              const errors = getODataErrors(response.errors, i18n);
              editorView.setErrors({
                [fieldName]: errors,
              });
            }
          })
          .finally(withUiBlock(view.grid.gridView.$el));
      })
        .catch(() => {
          editorView.setErrors({
            [fieldName]: i18n.getString('GenericErrorMessage_Short'),
          });
        })
        .finally(withUiBlock(view.grid.gridView.$el));
    },
  });
}

